import React from 'react';
import firebase from '../components/Firestore';
import ConfirmationNote from '../components/ConfirmationNote';
import StoreContact from '../components/StoreContact';
if (process.env.NODE_ENV !== 'production') {
    var mock = require("../mocks/ordermock.json")
}
var moment = require('moment');

class ConfirmationPage extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            shopLogo: null,
            shopName: "Loading...",
            shopAddress: "Loading...",
            shopPhoneNumber: "Loading...",
        }
    }

    componentDidMount() {
        if (process.env.NODE_ENV === 'production') {
            firebase.firestore().collection('orders')
            .doc(this.props.match.params.id)
            .get()
            .then(task => {
                    var order = task.data();
                    var date = moment.unix(order.pickup_time);
                    console.log(date);
                    this.setState({
                        orderDatetime: date.format('MMMM DD [at] h:mm A'),
                        orderItem: order.item_description, 
                        orderId: 24689,
                        contactEmail: order.email,
                        contactNumber: order.phone
                    });
            });
            firebase.firestore().collection('shops')
            .where('name', "==", "Backyard Bird Shop")
            .get()
            .then(snapshot => {
                snapshot.forEach(task => {
                    var shop = task.data();
                    this.setState({
                      shopName: shop.name,
                      shopAddress: shop.address,
                      shopPhoneNumber: shop.phone_number,
                      shopId: task.id,
                      shopLogo: require("../images/birdshop-logo.png"), // need to replace with ref to shop logo
                      shopHours: shop.hours,
                      intervalToOrder: shop.mins_to_start,
                      orderMax: shop.orders_per_quarter_hour
                    });
                });
            });
        } else {
            this.setState({
                shopName: mock.name,
                shopAddress: mock.address,
                shopPhoneNumber: mock.phone_number,
                shopNote: mock.shop_note,
                shopId: mock.shop_id,
                shopLogo: require("../images/birdshop-logo.png"),
                orderDatetime: mock.order_time,
                orderItem: mock.description,
                orderId: mock.order_id
            });
        }
    }

    render() {
        return(
            <React.Fragment>
                    <div className="flex-thirds">
                        <div className="flex-col"> 
                            <StoreContact 
                                logo={this.state.shopLogo}
                                name={this.state.shopName}
                                address={this.state.shopAddress} 
                                phone={this.state.shopPhoneNumber}
                            />
                        </div>
                        <div className="flex-col">
                            <ConfirmationNote
                                shopName={this.state.shopName}
                                orderId={this.state.orderId}
                                orderDatetime={this.state.orderDatetime}
                                orderItem={this.state.orderItem}
                                orderPhone={this.state.contactPhone}
                                orderEmail={this.state.contactEmail}
                            />
                        </div>
                        <div className="flex-col"/>
                    </div>
            </React.Fragment>
        );
    }

}

export default ConfirmationPage;
